import { IElement, IElementPayload, IQuestionnaire, IQuestionnairePayload, Question } from "src/common/types";
import { javaDateToJS } from "src/helpers";
import { QuestionnaireMap } from "../types";

/**
 * Property `conf` from BE is a stringified JSON
 * must be converted to Object
 */
export const mapElement = (element: IElementPayload): IElement => {
  const { config } = element;
  return {
    ...element,
    config: config ? JSON.parse(config) : null
  };
};

export const mapMyQuestionnaire = (questionnaire: IQuestionnairePayload): IQuestionnaire => {
  const {
    additionalComments,
    submissionStatus,
    submissionDueDate,
    submissionDate,
    template: { elements, instructions, instructionsMap },
    talk: { cycle, participant: feedbackTaker, scheduledDate: talkScheduledDate, status: talkStatus },
    questionnaireType
  } = questionnaire;
  return {
    additionalComments: additionalComments || "",
    cycle,
    elements: elements.map(mapElement),
    feedbackTaker,
    instructions,
    instructionsMap,
    questionnaireType,
    submissionDate: submissionDate ? javaDateToJS(submissionDate) : null,
    submissionDueDate: javaDateToJS(submissionDueDate),
    submissionStatus,
    talkScheduledDate: talkScheduledDate ? javaDateToJS(talkScheduledDate) : null,
    talkStatus
  };
};

/**
 * Create Formik Values Object from questionnaire
 * { `questionId`: response }
 */
export const getQuestionsFromQuestionnaire = (elements: IElement[]): QuestionnaireMap => {
  return (
    elements
      // Only elements
      .filter(element => element.question)
      .reduce((acc, element) => {
        const question = element.question as Question;
        return {
          ...acc,
          [question.id as string]: question
        };
      }, {})
  );
};
